import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { useSelector } from 'react-redux';
import warningSrc from './warning.svg';
import styles from './FailedPaymentModal.module.css';
import { selectAccountDetails } from '@mm/state/selectors/subscriptionSelectors';
import { useCallback, useEffect } from 'react';
import moment from 'moment';
import { IS_PROD_URL } from '../../helpers/plugins/constants';

const key = 'failed_payment_modal_last_seen';

export const useGetIsDissmissedFailedPaymentError = () => {
  const facebookPage = useSelector(activeFacebookPageSelector);
  const time = localStorage.getItem(key);

  const isFailedPaymentErrorDismissed =
    time &&
    moment().diff(
      moment(parseInt(time, 10)),
      IS_PROD_URL ? 'hours' : 'minutes',
    ) < 24 &&
    facebookPage?.subscription?.failedPayment;

  const dismissFailedPaymentError = () =>
    localStorage.setItem(key, moment.now().toString());

  return {
    isFailedPaymentErrorDismissed,
    dismissFailedPaymentError,
  };
};

export const useFailedPaymentModal = () => {
  const accountDetails = useSelector(selectAccountDetails);
  const facebookPage = useSelector(activeFacebookPageSelector);
  const { openNewInfoModal, closeModal } = useModalActions();
  const { isFailedPaymentErrorDismissed, dismissFailedPaymentError } =
    useGetIsDissmissedFailedPaymentError();

  const onUpdateDetailes = useCallback(() => {
    window.open(accountDetails?.account?.editBillingLink, '_blank');
    closeModal();
  }, [accountDetails?.account?.editBillingLink, closeModal]);

  const openFailedPaymentModal = useCallback(() => {
    openNewInfoModal({
      title: 'Your payment failed.',
      description:
        'Please check your credit card details and try one more time. To keep your subscription you may need to update your payments details.',
      button: 'Update Details',
      onClick: onUpdateDetailes,
      image: warningSrc,
      css: { container: styles.container, button: styles.button },
    });
  }, [onUpdateDetailes, openNewInfoModal]);

  useEffect(() => {
    if (isFailedPaymentErrorDismissed) {
      return;
    }

    if (
      facebookPage?.subscription?.failedPayment &&
      accountDetails?.account?.editBillingLink
    ) {
      dismissFailedPaymentError();
      openFailedPaymentModal();
    }
  }, [
    facebookPage?.subscription?.failedPayment,
    accountDetails?.account?.editBillingLink,
    openFailedPaymentModal,
    isFailedPaymentErrorDismissed,
  ]);
};
